// extracted by mini-css-extract-plugin
module.exports = {"mainFooter":"footer_mainFooter__1k9da","mainFooterWrap":"footer_mainFooterWrap__1Vol4"};